import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

import * as $ from "jquery";

@Component({
	selector: 'app-sday',
	templateUrl: './sday.component.html',
	styleUrls: ['./sday.component.css']
})
export class SdayComponent implements OnInit {

	frm : FormGroup;

	dateArr:any = [];
	dayArr:any = [];
	weekArr:any = [];
	weekcssArr:any = [];
	currcssArr:any = [];

	passData:any = [];

	nowDate:any;

	selDay:any;
	selType:any;
	selHour:any;
	selMin:any;
	selWeek:any;
	selIdx:any;

	getMod:any;
	getType:any;
	getDay:any;
	getHour:any;
	getMin:any;
	getWeek:any;
	getAlarm:any;
	getIdx:any;

	dateChk:any;

	daytype:any = 1;

	dayReser:any = 0;

	time1 = [
		{hour: "00"},
		{hour: "01"},
		{hour: "02"},
		{hour: "03"},
		{hour: "04"},
		{hour: "05"},
		{hour: "06"},
		{hour: "07"},
		{hour: "08"},
		{hour: "09"},
		{hour: "10"},
		{hour: "11"}
	];

	time2 = [
		{hour: "12"},
		{hour: "13"},
		{hour: "14"},
		{hour: "15"},
		{hour: "16"},
		{hour: "17"},
		{hour: "18"},
		{hour: "19"},
		{hour: "20"},
		{hour: "21"},
		{hour: "22"},
		{hour: "23"}
	];

	timeOpt:any

	constructor(
		private http: HttpClient,
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public getData,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = new FormGroup({
			ntchk: new FormControl({
				value: '',
				disabled: true
			}),
			nthour: new FormControl({
				value: '',
				disabled: true
			}),
			ntmin: new FormControl({
				value: '',
				disabled: true
			}),
			rtchk: new FormControl(''),
			rthour: new FormControl(''),
			rtmin: new FormControl(''),
			rtalarm: new FormControl(''),
		});

		if( typeof this.getData['mod'] == "undefined" || this.getData['mod'] == null ){ this.getMod = ""; }
		else{ this.getMod = this.getData['mod']; }

		if( typeof this.getData['rtchk'] == "undefined" || this.getData['rtchk'] == null ){ this.getType = ""; }
		else{ this.getType = this.getData['rtchk']; }

		if( typeof this.getData['rday'] == "undefined" || this.getData['rday'] == null ){ this.getDay = ""; }
		else{ this.getDay = this.getData['rday']; }

		if( typeof this.getData['rthour'] == "undefined" || this.getData['rthour'] == null ){ this.getHour = ""; }
		else{ this.getHour = this.getData['rthour']; }

		if( typeof this.getData['rtmin'] == "undefined" || this.getData['rtmin'] == null ){ this.getMin = ""; }
		else{ this.getMin = this.getData['rtmin']; }

		if( typeof this.getData['rweek'] == "undefined" || this.getData['rweek'] == null ){ this.getWeek = ""; }
		else{ this.getWeek = this.getData['rweek']; }

		if( typeof this.getData['alarm'] == "undefined" || this.getData['alarm'] == null ){ this.getAlarm = 0; }
		else{ this.getAlarm = this.getData['alarm']; }

		if( typeof this.getData['sidx'] == "undefined" || this.getData['sidx'] == null ){ this.getIdx = ""; }
		else{ this.getIdx = this.getData['sidx']; }
	}

	ngOnInit() {

		if( this.getData['type'] )
		{
			this.daySel(this.getData['type']);
			this.frm.get('ntchk').setValue(this.getData['tchk']);

			if( this.getData['tchk'] == "오전" )
			{
				this.timeOpt = this.time1;
			}
			else if( this.getData['tchk'] == "오후" )
			{
				this.timeOpt = this.time2;
			}

			this.frm.get('nthour').setValue(this.getData['thour']);
			this.frm.get('ntmin').setValue(this.getData['tmin']);
			this.frm.get('rtchk').setValue(this.getData['rtchk']);
			this.frm.get('rthour').setValue(this.getData['rthour']);
			this.frm.get('rtmin').setValue(this.getData['rtmin']);
			this.frm.get('rtalarm').setValue(this.getData['alarm']);
		}

		this.getReserDay();
	}

	async getReserDay() {
		var formData: any = new FormData();
				formData.append("sidx", this.getIdx);

		this.http.post(this.env.API_URL + 'api/reser.day.php', formData).subscribe((response) => {
			this.nowDate = response['nowDate'];
			this.dateArr = response['date'];
			this.dayArr = response['day'];
			this.weekArr = response['week'];
			this.weekcssArr = response['weekcss'];
			this.currcssArr = response['currcss'];

			this.selDay = (this.getDay)?this.getDay:response['hday'];
			this.selType = (this.getType)?this.getType:response['htype'];
			this.selHour = (this.getHour)?this.getHour:response['hhour'];
			this.selMin = (this.getMin)?this.getMin:response['hmin'];
			this.selWeek = (this.getWeek)?this.getWeek:response['hweek'];
			this.selIdx = (this.getIdx)?this.getIdx:response['sidx'];

			this.frm.get('rtchk').setValue(this.selType);
			this.frm.get('rthour').setValue(this.selHour);
			this.frm.get('rtmin').setValue(this.selMin);

			if( this.getMod == 1 )
			{
				this.openLayer(2);
				this.selDate(this.selDay, this.selWeek, this.selIdx);
			}
		});
	}

	selDate(d:any, w:any, i:any) {
		$(".date-list li .box div").removeClass("curr");
		$(".date-list li:eq("+i+") .box div").addClass("curr");

		this.selDay = d;
		this.selWeek = w;
		this.selIdx = i;

		let year = d.substr(0,4);
		let month = d.substr(5,2);

		this.nowDate = year+"년 "+month+"월";
	}

	typeChange() {
		this.selType = this.frm.get('rtchk').value;
	}

	hourChange() {
		this.selHour = this.frm.get('rthour').value;
	}

	minChange() {
		this.selMin = this.frm.get('rtmin').value;
		if( !this.selMin ){ this.selMin = "00"; }
	}

	async closeModal() {
		this.dialogRef.close();
	}

	async dayConfirm() {
		if( this.daytype == 2 )
		{
			if( !this.frm.get('ntchk').value )
			{
				this.func.bottomToast("오전/오후를 선택해주세요.");
				return false;
			}

			if( !this.frm.get('nthour').value )
			{
				this.func.bottomToast("시간(시)을 선택해주세요.");
				return false;
			}
		}

		this.passData['type'] = this.daytype;
		this.passData['tchk'] = this.frm.get('ntchk').value;
		this.passData['thour'] = this.frm.get('nthour').value;
		this.passData['tmin'] = this.frm.get('ntmin').value;

		this.dialogRef.close({
			event: 'close',
			data: this.passData
		});
	}

	async reserConfirm() {
		this.passData['type'] = 3;
		this.passData['reser'] = this.dayReser;
		this.passData['rday'] = this.selDay;
		this.passData['rweek'] = this.selWeek;
		this.passData['rtchk'] = this.frm.get('rtchk').value;
		this.passData['rthour'] = this.frm.get('rthour').value;
		this.passData['rtmin'] = this.frm.get('rtmin').value;
		this.passData['alarm'] = this.frm.get('rtalarm').value;
		this.passData['sidx'] = this.selIdx;

		this.dialogRef.close({
			event: 'close',
			data: this.passData
		});
	}

	openLayer(i) {
		var a = i - 1;

		$(".tab-ibox li a").removeClass("curr");
		$(".tab-ibox li:eq("+a+") a").addClass("curr");
		$(".layer-box").addClass("dn");
		$("#lay"+i).removeClass("dn");

		if( i == 2 )
		{
			this.dayReser = 1;
		}
	}

	daySel( type ) {
		var a = type - 1;

		$(".selday-box li a").removeClass("curr");
		$(".selday-box li a i").removeClass("bi-check-circle-fill").addClass("bi-check-circle");
		$(".selday-box li:eq("+a+") a").addClass("curr");
		$(".selday-box li:eq("+a+") a i").removeClass("bi-check-circle").addClass("bi-check-circle-fill");

		this.daytype = type;

		if( type == 2 )
		{
			this.frm.get('ntchk').enable();
			this.frm.get('nthour').enable();
			this.frm.get('ntmin').enable();

		}
		else
		{
			this.frm.get('ntchk').disable();
			this.frm.get('nthour').disable();
			this.frm.get('ntmin').disable();
		}
	}

	onChange( chk:any ) {
		this.frm.get('nthour').setValue("");
		if( chk.value == "오전" )
		{
			this.timeOpt = this.time1;
		}
		else if( chk.value == "오후" )
		{
			this.timeOpt = this.time2;
		}
	}
}
